import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function useCounties() {
  const [counties, setCounties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    const t = setTimeout(() => {
      axios.get(`${API}/returns/geo/counties`).then(
        (r) => { if (!cancelled) { setCounties(r.data.items || []); setLoading(false); } },
        (e) => { if (!cancelled) { setError(e.response?.data?.detail || e.message); setLoading(false); } },
      );
    }, 0);
    return () => { cancelled = true; clearTimeout(t); };
  }, []);
  return { counties, loading, error };
}

export function useCities(countyId) {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!countyId) {
      const tt = setTimeout(() => setCities([]), 0);
      return () => clearTimeout(tt);
    }
    let cancelled = false;
    const t = setTimeout(() => {
      setLoading(true);
      axios.get(`${API}/returns/geo/cities`, { params: { county_id: countyId } }).then(
        (r) => { if (!cancelled) { setCities(r.data.items || []); setLoading(false); } },
        (e) => { if (!cancelled) { setError(e.response?.data?.detail || e.message); setLoading(false); } },
      );
    }, 0);
    return () => { cancelled = true; clearTimeout(t); };
  }, [countyId]);
  return { cities, loading, error };
}
